import React from 'react';
import { Header, Button } from 'semantic-ui-react';
import * as actions from './state/actions';
import FilePreview from '../../common/FilePreview';
import { columnsOptions } from './fixtures';

const filterHeaderFields = data => {
  return data.map(d => {
    return {
      Id: d.Id,
      HeaderId: d.HeaderId,
      FieldName: d.FieldName,
      ColumnNumber: d.ColumnNumber,
    };
  });
};

export const ImportPreview = ({
  dispatch,
  clearImportStudentsData,
  uploadAnotherFile,
  fileData,
  updatePreviewData,
  header,
  notificationSystem,
}) => (
  <div className="file-preview--header-wrapper">
    <Header content="Import Preview" floated="left" color="orange" />
    <Button
      className="file-preview--clear-mapping file-preview--header-button"
      size="tiny"
      onClick={() => {
        dispatch(actions.addColumnMapping([]));
      }}
    >
      Clear Mapping
    </Button>
    <Button
      className="file-preview--upload-new-file file-preview--header-button"
      size="tiny"
      onClick={() => {
        clearImportStudentsData();
        uploadAnotherFile();
      }}
    >
      Upload Another File
    </Button>
    <FilePreview
      fileData={fileData}
      updatePreviewData={updatePreviewData}
      header={filterHeaderFields(header)}
      notificationSystem={notificationSystem}
      options={columnsOptions}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/importstudents/ImportPreview.js